<template>
  <div>
    <h4 class="title">
      {{ $t('elanlar') }}
    </h4>

    <VuePerfectScrollbar class="scroll-area mb-4">
      <div style="white-space: nowrap">
        <div
          v-for="a in announcements"
          :key="a.id"
          class="d-inline-block mr-3"
          style="cursor: pointer"
          @click="$router.push('/dashboard/announcement/'+a.id)"
        >
          <img
            :src="getPhoto(a.photo,'thumbnailCropped')"
            class="rounded-circle"
            style="width: 100px;"
            :alt="a.title"
            :class="{'active': a.isRead<1, 'inactive': a.isRead>0}"
          >
        </div>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {getPhoto} from "@/repositories/Utils";
import {mapState} from "vuex";
import {getAnnouncements} from "@/repositories/GeneralDataRepository";

export default {
  name: 'DashboardAnnouncements',
  components: {VuePerfectScrollbar},
  data() {
    return {
      announcements: [],
    };
  },

  computed: {
    ...mapState({
      token: state => state.auth.token,
    })
  },
  mounted() {

    getAnnouncements(this.token).then(data => {
      this.announcements = data;
    })

  },
  methods: {

    getPhoto(path, size) {
      return getPhoto(path, size);
    },
  }
}
</script>
<style scoped>

.title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 1rem;
}

.active{
  border: 2px solid #007bff !important;
}
.inactive{
  border: 2px solid #a3a5a6 !important;
  opacity: 0.7;
}


</style>